import HeaderLeft from '@elem/SVGIcon/DeltaProUltra/HeaderLeft';
import HeaderRight from '@elem/SVGIcon/DeltaProUltra/HeaderRight';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function DeltaProUltraHeader({ callback }: any) {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    // const [showHeader, setShowHeaer] = useState(true);

    // const handleClose = (e: any) => {
    //     e.stopPropagation();
    //     setShowHeaer(false);
    //     callback();
    // };

    const handleToCoupon = () => {
        const target = document.querySelector('#delta-pro-ultra-prelaunch-C') as HTMLElement;
        if (target) {
            window.scrollTo({
                top: target.offsetTop,
                behavior: 'smooth',
            });
        }
    };
    return (
        <>
            {/* {showHeader && ( */}
            <header className={`delta-prop-ultra-header announcement-bar ${css['delta-prop-ultra-header']}`} onClick={handleToCoupon}>
                <div className="ef-box">
                    <div className="header-content">
                        <HeaderLeft className="header-svg left" />
                        {/* <p className="header-offer">
                                {t.rich('header_offer', {
                                    n: (n: string) => <span className="no-wrap">{n}</span>,
                                })}
                            </p> */}
                        <p className="header-deal">
                            {t.rich('header_deal', {
                                p: (text: string) => <span className="price">{text}</span>,
                            })}
                        </p>
                        <HeaderRight className="header-svg right" />
                    </div>
                    {/* <svg className="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={handleClose}>
                            <path d="M7.75736 7.75729L16.2426 16.2426M16.2426 7.75729L7.75736 16.2426" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                        </svg> */}
                </div>
            </header>
            {/* )} */}
        </>
    );
}
